export const inviteErrorMessages: Record<string, string> = {
	USER_ALREADY_EXISTS: "A user with this email address already exists.",
	USER_ALREADY_ACTIVE: "This user is already active in your company.",
	USER_ALREADY_INVITED:
		"An invite has already been sent to this email address.",
	COMPANY_DOMAIN_NOT_AUTHORISED:
		"This email domain is not authorised for your company. A domain override reason is required.",
	RATE_LIMIT_EXCEEDED:
		"Too many invite requests. Please wait a moment before trying again.",
	INVITE_TOKEN_EXPIRED: "Your invite link has expired.",
	INVITE_TOKEN_INVALID:
		"This invite link is not valid. Please contact your administrator to resend.",
	USER_FIELD_IMMUTABLE:
		"This field cannot be changed after a user has been invited.",
	VERIFICATION_LOCKED:
		"This user's verification is temporarily locked. Please try again later.",
	DOMAIN_OVERRIDE_REASON_REQUIRED:
		"A reason is required to invite a user outside your authorised domains.",
	INVALID_EMAIL_CONFIRMATION: "Email addresses do not match.",
	COMPANY_NOT_FOUND: "Company not found.",
	UNAUTHORISED: "You do not have permission to invite users.",
	PREFLIGHT_FAILED:
		"We're having trouble processing your invite right now. Please try again in a moment.",
};

export const getInviteErrorMessage = (code: string | undefined): string =>
	(code && inviteErrorMessages[code]) ||
	"An error occurred sending the invite. Please try again.";
